import React from "react";

interface IconProps {
  fill?: string;
  size?: string;
}

const GridViewIcon: React.FC<IconProps> = ({ fill = "currentColor", size = "16" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 2C2.225 2 2 2.225 2 2.5V5.5C2 5.775 2.225 6 2.5 6H5.5C5.775 6 6 5.775 6 5.5V2.5C6 2.225 5.775 2 5.5 2H2.5ZM1 2.5C1 1.67188 1.67188 1 2.5 1H5.5C6.32812 1 7 1.67188 7 2.5V5.5C7 6.32812 6.32812 7 5.5 7H2.5C1.67188 7 1 6.32812 1 5.5V2.5ZM2.5 10C2.225 10 2 10.225 2 10.5V13.5C2 13.775 2.225 14 2.5 14H5.5C5.775 14 6 13.775 6 13.5V10.5C6 10.225 5.775 10 5.5 10H2.5ZM1 10.5C1 9.67188 1.67188 9 2.5 9H5.5C6.32812 9 7 9.67188 7 10.5V13.5C7 14.3281 6.32812 15 5.5 15H2.5C1.67188 15 1 14.3281 1 13.5V10.5ZM13.5 2H10.5C10.225 2 10 2.225 10 2.5V5.5C10 5.775 10.225 6 10.5 6H13.5C13.775 6 14 5.775 14 5.5V2.5C14 2.225 13.775 2 13.5 2ZM10.5 1H13.5C14.3281 1 15 1.67188 15 2.5V5.5C15 6.32812 14.3281 7 13.5 7H10.5C9.67188 7 9 6.32812 9 5.5V2.5C9 1.67188 9.67188 1 10.5 1ZM10.5 10C10.225 10 10 10.225 10 10.5V13.5C10 13.775 10.225 14 10.5 14H13.5C13.775 14 14 13.775 14 13.5V10.5C14 10.225 13.775 10 13.5 10H10.5ZM9 10.5C9 9.67188 9.67188 9 10.5 9H13.5C14.3281 9 15 9.67188 15 10.5V13.5C15 14.3281 14.3281 15 13.5 15H10.5C9.67188 15 9 14.3281 9 13.5V10.5Z"
      fill={fill}
    />
  </svg>
);

export default GridViewIcon;
